import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "name", "value"]
const _hoisted_2 = ["for"]

import { useField } from 'vee-validate';
import { computed, ref, Ref, toRef, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputTextarea',
  props: {
    name: {
        type: String,
        required: true,
    },
    label: {
        type: String,
        default: '',
    },
    id: {
        type: String,
        required: false,
        default: null,
    },
    showErrors: {
        type: Boolean,
        required: false,
        default: true,
    },
    value: {
        type: String,
        default: '',
    },
    // eslint-disable-next-line vue/require-default-prop
    modelValue: {
        type: null,
    },
    rules: {
        type: String,
        default: '',
    },
    validateOnChange: {
        type: Boolean,
        required: false,
        default: false,
    },
},
  emits: ['update:modelValue', 'input'],
  setup(__props, { emit }) {

const props = __props



const isFocused: Ref<boolean> = ref(false);
const isModelBound = computed(() => {
    return 'modelValue' in props;
});

const fieldRules = computed(() => props.rules);

const {
    value: inputValue,
    errorMessage,
    handleChange,
    handleBlur,
    validate,
} = useField(props.name, fieldRules.value, {
    initialValue: isModelBound.value ? props.modelValue : props.value,
    validateOnValueUpdate: false,
});

const handleInputEvent = (evt) => {
    isModelBound.value && emit('update:modelValue', evt.target.value);
    emit('input', evt);
    handleChange(evt, props.validateOnChange);
};

const handleChangeEvent = (evt?) => {
    if (evt) {
        isModelBound.value && emit('update:modelValue', evt.target.value);
        emit('input', evt);
        handleChange(evt);
    }
};

const validationListeners = computed(() => {
    // if no current errors use lazy validation handlers
    const listeners = {
        blur: handleBlur,
        change: handleChangeEvent,
        input: handleInputEvent,
    };

    // if current errors replace with eager handlers to validate changes immediately
    if (errorMessage.value) {
        listeners.blur = handleChangeEvent;
        listeners.input = handleChangeEvent;
    }

    return listeners;
});

const labelClasses = computed(() => {
    return {
        'c-input__textarea__label--has-value': !!inputValue.value || isFocused.value,
        'font-bold text-black': isFocused.value,
    };
});

if (isModelBound.value) {
    const modelValue = toRef(props, 'modelValue');
    watch(modelValue, newModelValue => {
        if (newModelValue !== inputValue.value) {
            inputValue.value = newModelValue;
            validate();
        }
    });
}

return (_ctx: any,_cache: any) => {
  const _component_InputErrorMessage = _resolveComponent("InputErrorMessage")!
  const _directive_prohibit_zoom = _resolveDirective("prohibit-zoom")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative", { 'pb-x6': __props.showErrors }])
  }, [
    _withDirectives(_createElementVNode("textarea", _mergeProps({
      id: __props.id,
      name: __props.name,
      value: _unref(inputValue),
      class: ["block w-full border bg-transparent border-silver o-scrollbar-y p-10 outline-none focus:outline-none", { 'border-roman': !!_unref(errorMessage) }]
    }, _ctx.$attrs, _toHandlers(_unref(validationListeners), true), {
      onFocus: _cache[0] || (_cache[0] = ($event: any) => (isFocused.value = true)),
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (isFocused.value = false))
    }), null, 16, _hoisted_1), [
      [_directive_prohibit_zoom]
    ]),
    _createElementVNode("label", {
      for: __props.id,
      class: _normalizeClass(["c-input__textarea__label", _unref(labelClasses)])
    }, _toDisplayString(__props.label), 11, _hoisted_2),
    (__props.showErrors)
      ? (_openBlock(), _createBlock(_component_InputErrorMessage, {
          key: 0,
          name: __props.name,
          class: "c-input__errors"
        }, null, 8, ["name"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})